<template>
  <div>
    <div id="dropdown" />
    <div class="mobileheader">
      <img class="logo" src="/img/logo-wintower.svg" />
       <div v-bind:class="[{'open':openmobilenav},'toggle']" @click="openmobilenav = openmobilenav = !openmobilenav"><span class="line"></span></div>
      </div>
    <div class="layout">

      <div class="nav">

        <div>
          <img class="logo" src="/img/logo-wintower.svg" />
          <main-menu />
        </div>



        <!-- user menu -->

        <div class="usernav-wrapper">


            <div class="contact">
              <h3>Ihr Ansprechpartner für alle Fälle:</h3>
                Wintower Reception:<br><a href="mailto:reception@wintower.ch">reception@wintower.ch</a><br> 052 262 02 22
            </div>

            <div class="usernav" @click="openusernav = !openusernav;">
              <div>
                <span>{{ auth.user.first_name == '-' ? '' : auth.user.first_name }}</span>
                <span>&nbsp;{{ auth.user.last_name == '-' ? '' : auth.user.last_name }}</span>
              </div>
              <img src="/img/arrow-up.svg" v-bind:class="[{ 'open' : openusernav }, 'icon']" />
            </div>
            <div v-bind:class="[{ 'open' : openusernav }, 'user-droptown']">
              <Link v-if="auth.user.owner" :href="`/users/${auth.user.id}/edit`">My Profile</Link>
              <Link v-if="auth.user.owner" href="/users">Manage Users</Link>
              <Link  href="/logout" method="delete" as="button">Logout</Link>
            </div>
        </div>
      </div>
      <main>
        <!-- mobile togglemenu -->

          <div class="menu-mobile" v-if="openmobilenav">
            <span @click="openmobilenav=false"><main-menu /></span>
          </div>
         <!-- mobile togglemenu -->

        <flash-messages />
        <slot />




      </main>

      <div class="image-bg">
        <span :style="'background-image:url(' + bgimage + ')'"></span>
      </div>
    </div>
  </div>

</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  data: function () {
    return {
     openusernav: false,
     openmobilenav: false,
     bgimage: null
    }
  },
  props: {
    auth: Object,
  },


}
</script>
